<template>
    <div v-if="reference">
        <div class="between-center mb">
            <h4 class="title subheading is-3">Notes</h4>

            <div v-if="canBeExternal" class="field">
                <o-switch
                        v-model="isExternal"
                        @input="partialUpdate"
                >
                    External
                </o-switch>
            </div>
        </div>
        <article class="media note-editor">
            <figure class="media-left">
                <p class="image is-64x64">
                    <img
                            :src="currentUser.avatar_url"
                            class="note-avatar"
                    >
                </p>
            </figure>

            <div class="media-content">
                <o-field
                        :message="getError('subject')"
                        :type="fieldType('subject')"
                        label="Subject"
                >
                    <o-input
                            v-model="subject"
                            placeholder="Subject"
                    />
                </o-field>

                <div class="field">
<!--                    <b-quill-->
<!--                            :error="getError('message')"-->
<!--                            v-model="message"-->
<!--                    />-->
                  <quill-editor
                      content-type="html"
                          v-model:content="message"
                          :options="editorOptions"/>
                </div>

                <div
                        v-if="referenceType === 'project'"
                        class="field"
                >
                    <o-checkbox v-model="is_milestone">Is Milestone</o-checkbox>
                </div>

                <nav class="level thread-level">
                    <div class="level-left subscribers-multiselect-wrapper">
                        <subscribers
                                :reference-type="referenceType"
                                :reference-id="referenceId"
                                @submitting="submittingSubscribers = $event"
                        />
                      <br>
                        <template v-if="reference.is_external">
                            <br>
                            <subscribed-contacts
                                    :reference-type="referenceType"
                                    :reference-id="referenceId"
                                    @submitting="submittingSubscribedContacts = $event"
                            />
                        </template>
                    </div>

                    <div class="level-right">
                        <div class="level-item">
                            <uploadcare
                                    ref="ucare"
                                    :multiple="true"
                                    v-model="files"
                                    format="object"
                            />
                        </div>

                        <div class="level-item">
                            <button
                                    v-submit="submitting"
                                    class="button is-dark"
                                    @click.prevent="handleCreate"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </nav>
            </div>
        </article>

        <note
                v-for="note in orderedNotes"
                :key="note.id"
                :id="note.id"
                class="media"
                @resend="openSubscribersModal"
        />

        <o-modal
:can-cancel="['escape', 'outside', 'button']"                v-model:active="isSubscribersModalActive"
                has-modal-card
        >
            <subscribers-modal :note="currentNote"/>
        </o-modal>
    </div>
</template>

<script>
    import SubscribedContacts from './NotesSubscribedContacts'
    import SubscribersModal from './modals/Subscribers'
    import HandlesForm from './../mixins/HandlesForm'
    import Subscribers from './NotesSubscribers'
    import {mapActions, mapGetters} from 'vuex'
    import Multiselect from '@vueform/multiselect'
    import Uploadcare from './Uploadcare'
    import Note from './Note'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        components: {
          QuillEditor,
            SubscribedContacts,
            SubscribersModal,
            Multiselect,
            Subscribers,
            Uploadcare,
            Note
        },

        mixins: [HandlesForm],

        props: ['referenceId', 'referenceType'],

        data() {
            return {
                submittingSubscribedContacts: false,
                isSubscribersModalActive: false,
                submittingSubscribers: false,
                is_milestone: false,
                currentNote: null,
                external: false,
                subject: '',
                text: '',
                files: [],
                editorOptions: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{'header': 1}, {'header': 2}],
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            [{'script': 'sub'}, {'script': 'super'}],
                            [{'indent': '-1'}, {'indent': '+1'}],
                            [{'direction': 'rtl'}],
                            [{'size': ['small', false, 'large', 'huge']}],
                            [{'header': [1, 2, 3, 4, 5, 6, false]}],
                            [{'color': []}, {'background': []}],
                            [{'font': []}],
                            [{'align': []}],
                            ['clean'],
                            ['link', 'image', 'video']
                        ]
                    }
                }
            }
        },

        computed: {
            ...mapGetters(['allUsers', 'notesByReference', 'currentUser', 'projectById', 'proposalById', 'taskById']),

            orderedNotes() {
                return _.sortBy(this.notes, ['id']).reverse()
            },

            notes() {
                const notes = this.notesByReference(this.referenceType, this.referenceId)
                let proposalNotes = []
                if(this.referenceType === 'project') {
                    proposalNotes = this.notesByReference('proposal', this.referenceId)
                }
                return [...notes, ...proposalNotes]
            },

            reference() {
                switch (this.referenceType) {
                    case 'task':
                        return this.taskById(this.referenceId)
                    case 'proposal':
                        return this.proposalById(this.referenceId)
                    case 'project':
                        return this.projectById(this.referenceId)
                }
            },

            isExternal: {
                get() {
                    return !!this.reference.is_external
                },
                set(value) {
                    this.reference.is_external = value
                }
            },

            canBeExternal() {
                return this.referenceType != 'proposal'
            }
        },

        watch: {
            submittingSubscribers() {
                this.submitting = this.submittingSubscribers || this.submittingSubscribedContacts
            },

            submittingSubscribedContacts() {
                this.submitting = this.submittingSubscribers || this.submittingSubscribedContacts
            }
        },

        methods: {
            ...mapActions(['createNote', 'partialUpdateTask', 'partialUpdateProject']),

            handleCreate() {
                let submit = this.wrapSubmit(this.createNote)

                submit({
                    message: this.message, files: this.files ? this.files : [],
                    reference_type: this.referenceType,
                    is_milestone: this.is_milestone,
                    reference_id: this.referenceId,
                    subject: this.subject,
                    // external: this.external
                }).then(res => {
                    this.is_milestone = false
                    this.$refs.ucare.clear()
                    this.subject = ''
                    this.message = ''

                    return res
                })
            },

            partialUpdate() {
                let payload = {
                    is_external: this.reference.is_external,
                    id: this.reference.id,
                    field: 'is_external'
                }

                switch (this.referenceType) {
                    case 'task':
                        return this.partialUpdateTask(payload)
                    case 'project':
                        return this.partialUpdateProject(payload)
                    // not applicable for proposals
                    case 'proposal':
                    default:
                        break
                }
            },

            openSubscribersModal(note) {
                this.isSubscribersModalActive = true
                this.currentNote = note
            }
        }
    }
</script>
